// extracted by mini-css-extract-plugin
export default {"apply_button_container":"UploadCartoonApplyButton_apply_button_container__bHyO+","disabled_button":"UploadCartoonApplyButton_disabled_button__zXFPa"};